import { ReportsDetailGraphicSchemaValues } from '@vision/ui/interfaces';
import { useFormikContext } from 'formik';
import {
  ReportsDetailGraphicMeasureMatrixQuestion,
  ReportsDetailGraphicMeasurePeriodAndValueComparison,
} from '../../../ReportsDetailGraphicMeasureComponents';

export function TableChart2ChartValueComponent() {
  const formik = useFormikContext<ReportsDetailGraphicSchemaValues>();

  const isMatrixQuestion = (measure: string) =>
    ['matrix-question-csat-overview', 'matrix-question-response-count'].includes(measure);

  if (isMatrixQuestion(formik.values.selectedMeasure)) {
    return <ReportsDetailGraphicMeasureMatrixQuestion multiple={false} />;
  }

  if (formik.values.selectedMeasure === 'overview-compared') {
    return <ReportsDetailGraphicMeasurePeriodAndValueComparison />;
  }

  return null;
}
